import React from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';

/**
 * Renders MUI Icon button to remove product setting.
 * @returns {React.FC}
 */

const PackageItemActions = ({ deletePackageItem }) => (
  <IconButton size="small" onClick={deletePackageItem}>
    <Tooltip title="Delete package setting">
      <DeleteIcon />
    </Tooltip>
  </IconButton>
);

export default PackageItemActions;

PackageItemActions.propTypes = {
  deletePackageItem: PropTypes.func.isRequired
};
